export enum enumChartOfAccountType {
  General = 1,
  Debtor,
  Creditor,
  Stock,
  VAT,
  Tax
}

export namespace enumChartOfAccountType {
  export function values() {
    return Object.keys(enumChartOfAccountType).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

